import React from "react";
import styled from "styled-components";

import { Box, Flex, Text, Input } from "atoms";

export const RadioFieldBase = styled(Box)`
  position: relative;
  display: grid;
  align-items: center;

  label {
    font-size: 1.4rem;
  }

  input[type="radio"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
    min-width: 1.8rem;
    min-height: 1.8rem;
    width: 1.8rem;
    height: 1.8rem;
    border: 1px solid
      ${(props) =>
        props.autoFocus
          ? props.theme.colors.secondary[700]
          : props.theme.colors.neutral[300]};
    cursor: pointer;
    border-radius: 50%;
    background-clip: content-box;
    padding: 3px;
  }
  input[type="radio"]:checked {
    background-color: ${(props) => props.theme.colors.secondary[700]};
    border: 1px solid ${(props) => props.theme.colors.secondary[700]};
  }
`;

export const RadioField = ({ label, error, warning, autoFocus, ...props }) => (
  <RadioFieldBase autoFocus={autoFocus}>
    <Flex aI="center" as="label">
      <Input
        type="radio"
        width="auto"
        mt={0}
        ml={0}
        mr={2}
        autoFocus={autoFocus}
        {...props}
      />

      <Text
        color="neutral.700"
        fontFamily="NeometricRegular"
        fontSize={{ xs: "1.4rem", md: "1.6rem" }}
      >
        {label}
      </Text>
    </Flex>
    {/* {error && <Error text={error} />}
    {warning && <Warning text={warning} />} */}
  </RadioFieldBase>
);
